module.exports = __webpack_public_path__ + "banquet/components/Footer/images/banquet_footer_logo_3x.fa8891e64e4203cd49138de4ebce0fc6.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Footer/images/banquet_footer_logo_3x.png
// module id = 531
// module chunks = 1